/** Desktop-only enhancements around the theme's existing Swiper carousel. */
class JournalCarousel extends HTMLElement {
  #abort;
  #motion;
  #instance;
  #update;

  connectedCallback() {
    this.disconnectedCallback();
    this.#abort = new AbortController();
    this.#motion = matchMedia("(prefers-reduced-motion: reduce)");
    const carousel = this.querySelector("carousel-slider");
    const bind = (instance) => {
      this.#unbind();
      this.#instance = instance;
      const speed = instance.params.speed;
      this.#update = () => {
        if (instance.destroyed) return;
        instance.params.speed = this.#motion.matches ? 0 : speed;
        const bar = this.querySelector('[ref="pagination"]');
        if (bar) {
          bar.setAttribute("role", "progressbar");
          bar.setAttribute("aria-label", this.dataset.progressLabel);
          bar.setAttribute("aria-valuemin", "0");
          bar.setAttribute("aria-valuemax", "100");
          bar.setAttribute("aria-valuenow", String(Math.round(
            ((instance.snapIndex + 1) / Math.max(1, instance.snapGrid.length)) * 100
          )));
        }
      };
      instance.on("slideChange snapGridLengthChange resize", this.#update);
      this.#update();
    };
    this.addEventListener("carousel:ready", (event) => bind(event.detail.swiperInstance), {
      capture: true,
      signal: this.#abort.signal,
    });
    if (carousel.swiperInstance) bind(carousel.swiperInstance);
    this.#motion.addEventListener("change", () => {
      this.#update?.();
      if (this.#instance && !this.#instance.destroyed && this.#motion.matches) {
        this.#instance.slideTo(this.#instance.activeIndex, 0);
      }
    }, { signal: this.#abort.signal });
    this.addEventListener("keydown", (event) => {
      if (!event.target.closest("carousel-slider")) return;
      if (event.altKey || event.ctrlKey || event.metaKey || !["ArrowLeft", "ArrowRight"].includes(event.key)) return;
      const instance = this.#instance;
      if (!instance || instance.destroyed) return;
      event.preventDefault();
      if (event.key === "ArrowLeft") instance.slidePrev();
      else instance.slideNext();
    }, { signal: this.#abort.signal });
  }

  #unbind() {
    if (this.#instance && !this.#instance.destroyed && this.#update) {
      this.#instance.off("slideChange snapGridLengthChange resize", this.#update);
    }
    this.#instance = undefined;
    this.#update = undefined;
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#unbind();
  }
}

if (!customElements.get("journal-carousel")) customElements.define("journal-carousel", JournalCarousel);
